import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const scrollPositions = new Map<string, number>();

export function ScrollManager() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (navigationType === 'POP') {
      const y = scrollPositions.get(location.key) ?? 0;
      window.scrollTo(0, y);
    } else {
      window.scrollTo(0, 0);
    }

    return () => {
      scrollPositions.set(location.key, window.scrollY);
    };
  }, [location.key, navigationType]);

  return null;
}
